var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 3.75A5.256 5.256 0 0 0 3.75 9 5.256 5.256 0 0 0 9 14.25 5.256 5.256 0 0 0 14.25 9 5.256 5.256 0 0 0 9 3.75Zm2.732 3.49L8.34 11.28a.403.403 0 0 1-.303.144H8.03a.404.404 0 0 1-.3-.134L6.276 9.674a.404.404 0 1 1 .6-.54l1.144 1.27 3.094-3.683a.404.404 0 0 1 .618.52Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.8c4ce59bc1864096fd9ded6c17490377.svg";